import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import axios from 'axios'

interface User {
  id: number
  idyangu_id: string
  phone: string
  name: string
  email?: string
  role: string
  is_creator: boolean
  is_reviewer: boolean
}

export const useAuthStore = defineStore('auth', () => {
  const user = ref<User | null>(null)
  const loading = ref(false)
  const idyanguWalletUrl = ref<string>('')

  async function checkSession() {
    try {
      loading.value = true
      const response = await axios.get('/api/auth/me', { withCredentials: true })
      if (response.data?.user) {
        user.value = response.data.user
        idyanguWalletUrl.value = response.data.idyanguWalletUrl
        return true
      }
      user.value = null
      return false
    } catch (error) {
      user.value = null
      return false
    } finally {
      loading.value = false
    }
  }

  async function fetchUser() {
    return await checkSession()
  }

  async function logout() {
    try {
      const response = await axios.post('/api/auth/logout', {}, { withCredentials: true })
      user.value = null
      // Redirect to IdYangu URL from API response (from IDYANGU_URL env)
      const idyanguUrl = response.data.idYanguBaseUrl
      window.location.href = idyanguUrl
    } catch (error) {
      // Even if logout fails, clear local state
      user.value = null
      throw error
    }
  }

  const isAuthenticated = computed(() => user.value !== null)

  return {
    user,
    loading,
    isAuthenticated,
    idyanguWalletUrl,
    checkSession,
    fetchUser,
    logout
  }
})

